import { getHasCompletedAllSteps } from '../pages/Hub/helpers';
import getHasMissingInformation from '../pages/Introduction/getHasMissingInformation';
import { Context } from './model';

const guards = {
  hasCompletedAllSteps: ({ getModuleData }: Context) =>
    getHasCompletedAllSteps(getModuleData()),
  hasMissingInformation: ({ getModuleData }: Context) =>
    getHasMissingInformation(getModuleData()),
  shouldNotAskForEpCguAgreement: ({ getModuleData }: Context) => {
    return !getModuleData().viewer.companyUser.shouldAskForEpCguAgreement;
  },
};

export default guards;
